import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-member-document-type.reducer';
import { IConsMemberDocumentType } from 'app/shared/model/cons-member-document-type.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsMemberDocumentType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consMemberDocumentTypeList = useAppSelector(state => state.consMemberDocumentType.entities);
  const loading = useAppSelector(state => state.consMemberDocumentType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-member-document-type-heading" data-cy="ConsMemberDocumentTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.home.title">Cons Member Document Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.home.createLabel">
              Create new Cons Member Document Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consMemberDocumentTypeList && consMemberDocumentTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consMemberDocumentTypeList.map((consMemberDocumentType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consMemberDocumentType.id}`} color="link" size="sm">
                      {consMemberDocumentType.id}
                    </Button>
                  </td>
                  <td>{consMemberDocumentType.name}</td>
                  <td>{consMemberDocumentType.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consMemberDocumentType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consMemberDocumentType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consMemberDocumentType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consMemberDocumentType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.home.notFound">
                No Cons Member Document Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsMemberDocumentType;
